<div class="c-form-field c-form-field--d" [ngClass]="cssClass">
  <img class="c-form-field__img--pql" alt="PQL" src="assets/img/rotation-trees/pql.svg" />
  <label class="c-form-field__inner mb-5">
    <textarea
      [formControl]="pqlString"
      (blur)="onTouched()"
      autocomplete="off"
      placeholder="Enter text..."
      type="text"
      class="c-form-field__textarea c-form-field__textarea--pql"
      [mentionConfig]="mentionConfig"
    ></textarea>
    <span class="c-form-field__label">
      IREV Query Language
      <span *ngIf="message" class="c-form-field__tooltip" p500UITooltip [tooltipData]="message">?</span>
    </span>
  </label>
  <span class="c-form-field__label"> * use &#64; or # symbols for auto-complete </span>
</div>

<div class="p500-ui-modal__body-title">
  <div class="title">Rules for PQL</div>
  <div class="actions">
    <div class="action">
      <button p500-ui-button-icon size="small" color="primary" type="button" (click)="addCondition()">
        <p500-ui-icon name="plus-circle"></p500-ui-icon>
      </button>
    </div>
  </div>
</div>

<div class="c-conditions c-conditions--d">
  <div class="c-conditions__groups-conditions c-form c-form--d">
    <p500-ui-preset-condition
      *ngFor="let pqlParsedControl of pqlParsed.controls; let i = index"
      [index]="i"
      [formControl]="pqlParsedControl"
      [name]="'pqlScheme'"
      [conditions]="conditions"
      [getValueComponentByType]="presetHelpers.getValueComponentByType"
      [getSignsData]="presetHelpers.getSignsDataPql"
      (remove)="removeCondition($event)"
      class="c-conditions__condition c-form__section"
    >
    </p500-ui-preset-condition>
  </div>
</div>
